import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig, getDataRequirements } from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: manifest.id,
  module: { manifest, Component, defaultConfig, getDataRequirements },
  catalog: {
    description: manifest.description,
    domain: "ip-blocking",
    visual: "Summary",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-8",
};
